import { CloudCheck, CloudSync, CloudAlert, Cloud, CloudDownload } from "lucide-react";

type CloudStatusIconProps = {
    status: "idle" | "success" | "saving" | "loading" | "error"
};
export function CloudStatusIcon({ status }: CloudStatusIconProps) {
    switch (status) {
        case "idle":
            return <Cloud />;
        case "success":
            return <CloudCheck color="green" />;
        case "saving":
            return <CloudSync color="orange" />;
        case "loading":
            return <CloudDownload color="orange" />;
        case "error":
            return <CloudAlert color="red" />;
    }
}